import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { Document } from 'types';
import { getDocumentsByIds } from 'modules/documents/api/getDocumentsByIds';

type UseGetDocumentsProps = {
  documentIds: string[];
};

export const useGetDocuments = ({ documentIds }: UseGetDocumentsProps) => {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchDocuments = useCallback(async () => {
    try {
      if (documentIds.length > 0) {
        setIsLoading(true);

        const documents = await store.dispatch(
          getDocumentsByIds({ documentIds })
        );

        setDocuments(documents);
      }
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [documentIds]);

  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  return {
    data: { documents },
    isLoading,
    isError,
    actions: { setIsLoading },
  };
};
